Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Currency", {
    enumerable: true,
    get: function() {
        return Currency;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class Currency {
    constructor(currencyDef){
        _define_property(this, "uid", void 0);
        _define_property(this, "code", void 0);
        _define_property(this, "symbol", void 0);
        this.uid = currencyDef.uid;
        this.code = currencyDef.code;
        this.symbol = currencyDef.symbol;
    }
}
